/* Fietskoop Premium — kleine, uitstelbare verbeteringen (geen frameworks) */
(function () {
  'use strict';

  /* Scroll-reveal (respecteert reduced motion) */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.fk-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.fk-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Toast */
  var toast;
  function showToast(msg) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'fk-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }

  function refreshCartUI() {
    /* Dawn: vernieuw cart-icon bubble via section rendering */
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-icon-bubble' : '/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-icon-bubble'];
        if (!html) return;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var target = document.getElementById('cart-icon-bubble');
        var fresh = holder.querySelector('.shopify-section') || holder.firstElementChild;
        if (target && fresh) target.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }

  /* Quick add (Maak je fiets compleet) */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-fk-quick-add]');
    if (!btn) return;
    ev.preventDefault();
    var id = btn.getAttribute('data-fk-quick-add');
    if (!id || btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-failed');
      return r.json();
    }).then(function () {
      btn.dataset.added = 'true';
      btn.innerHTML = '✓';
      btn.setAttribute('aria-label', 'Toegevoegd aan winkelwagen');
      showToast('Toegevoegd aan je winkelwagen');
      refreshCartUI();
      if (window.dataLayer) window.dataLayer.push({ event: 'fk_accessory_added', item_variant_id: id });
    }).catch(function () {
      showToast('Toevoegen is niet gelukt — probeer het opnieuw');
    }).finally(function () { btn.disabled = false; });
  });

  /* Analytics events (alleen dataLayer pushes, geen tracking zonder consent-laag) */
  if (window.dataLayer) {
    var pd = document.querySelector('[data-fk-product-handle]');
    if (pd) window.dataLayer.push({ event: 'fk_product_viewed', product_handle: pd.getAttribute('data-fk-product-handle') });
  }
})();
